import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Base64 } from "js-base64";
import React, { createRef } from 'react';
import 'Home/Components/Home/Home.css';
import { Link } from 'react-router-dom';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import SuccessModal from 'Home/CommonResources/SuccessModal/SuccessModal';
import ReactHtmlParser from 'react-html-parser';
import axios from 'axios';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader.js'
import ModuleDetails from '../ModuleDetails/ModuleDetails';
import LatestUpdates from '../LatestUpdates/LatestUpdates';
import BirthdayDetails from '../BirthdayDetails/BirthdayDetails';
import NoticeDetails from '../NoticeDetails/NoticeDetails';
import EventDetails from '../EventDetails/EventDetails';
import LectureDetails from '../LectureDetails/LectureDetails';
import LeaderboardDetails from '../LeaderboardDetails/LeaderboardDetails';
import Spinner from 'Home/CommonResources/SpinnerLoader/Spinner';
import Axios from 'axios';
import EmployeesOnLeave from '../EmployeesOnLeave/EmployeesOnLeave';
// import AnniversaryDetails from '../AnniversaryDetails/AnniversaryDetails';


class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalMessage: '',
            refreshingPage: false,

            // VARIABLES FOR SUCCESS MODAL
            successModal: false,
            successModalType: '',
            successMessage: '',

            // VARIABLES FOR OVERDUE MESSAGE
            overdueCondition: '',
            overdueMessage: '',
            stepNumber: '',
            alertModal: false,
            dueDate: "",
            dateAfterSevenDays: "",
            paymentAcceptanceObj: {},
            acceptanceSequenceIdArray: [],
            clientSubscriptionId: '',
            installmentId: '',
            acceptanceCount: '',
            showModuleDetails: false,
            daysCount: "seven",
            acceptingExtension: false,
            billingMessage: "",
            isBillContact: false,
            isAdmin: false,

            // VARIABLES TO GET INSTITUTE DETAILS
            instituteDetailsFetching: false,
            instituteName: '',
            instituteLogo: '',
            instituteMission: '',
            instituteVision: '',
            subscriptionWaring: '',
            streamName: '',

            instituteShortName: '',
            parentInstituteName: "",
            parentInstituteLogo: "",
            departmentVision: "",
            departmentMission: "",

            // VARIABLES TO GET ACADEMIC YEAR
            academicYearList: {},
            academicYearSequence: [],
            selectedAcademicYear: config.instructorInfo.AcaYearId,
            showAdminSetting: false,

            // VARIABLES TO GET DEPARTMENT DETAILS
            userAssignedStreams: {},
            selectedDepartment: config.stream_id || 0,
            selectAssignedStream: false,
            loadingStreams: false,
            tempSelectedDepartment: '',
            dueIIdArray: [],
            userAcceptedHTML: ''
        };
         this.leaderboardRef = createRef();
    }

    componentDidMount() {
        var InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details_wc"))));
        let yearId = InstructorDetailsJSON["data"]["AcaYearId"];
        let StreamId = InstructorDetailsJSON["data"]["StreamId"];

        this.setState({
            selectedAcademicYear: yearId,
            selectedDepartment: StreamId
        });

        // METHOD CALLED TO GET OVERDUE
        this.GetInstructorAssignedInstituteList();
    }

    getModuleDetails = () => {
        // METHOD CALLED TO GET DEPARTMENT DETAILS
        this.apiCallToGetInstituteDetails();

        // METHOD CALLED TO GET INSTITUTE DATA
        this.apiCallToGetInstituteData();

        // METHOD CALLED TO ADMIN DETAILS
        this.apiCallToGetAdminDetails();

        // METHOD CALLED TO GET ACADEMIC YEAR DETAILS
        this.apiCallToGetAcademicYearDetails();

        // METHOD CALLED TO GET DEPARTMENT DETAILS
        this.apiCallToGetDepartmentDetails();
    }
    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async () => {
        this.setState({
            instituteDetailsFetching: true,
        });

        let formData = new FormData();
        formData.append('getinstitutedata', true);
        formData.append("sid", this.state.selectedDepartment);
        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/generic_api.php',
            formData,
            {
                headers: headers,
            }
        ).then((response) => {
            let jsonResponse = response.data;

            if (jsonResponse.errorCode == '401') {
                this.apiCallToGetInstituteDetails();
            } else {

                function setCookie(name, value) {
                    document.cookie = name + "=" + (value || "") + ";path=/; ";
                }
                function setWcCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/;domain=.vmedulife.com";
                }

                var InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details_wc"))));

                InstructorDetailsJSON["data"]["InstitudeId"] = jsonResponse["institute_id"];
                InstructorDetailsJSON["data"]["Institute_iid"] = jsonResponse["institute_id"];
                InstructorDetailsJSON["data"]["InstituteLogo"] = jsonResponse["logo"];
                InstructorDetailsJSON["data"]["InstituteName"] = jsonResponse["name"];
                InstructorDetailsJSON["data"]["InstituteShortName"] = jsonResponse["short_name"];
                InstructorDetailsJSON["data"]["InstituteUrl"] = jsonResponse["url"];
                setCookie("user_details", Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))));
                setWcCookie("user_details_wc", Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))));

                this.setState({
                    instituteName: jsonResponse.name,
                    instituteLogo: jsonResponse.logo,
                    departmentMission: jsonResponse.mission,
                    departmentVision: jsonResponse.vision,
                    streamName: jsonResponse.streamName,
                    instituteDetailsFetching: false,
                });
            }
        }).catch(error => {
            console.log(error);

            this.setState({
                instituteDetailsFetching: false
            });
        });
    }

    // METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteData = async () => {
         let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getInstituteDetailsByIID',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    parentInstituteName:apiResult.data.InstituteName,
                    parentInstituteLogo:apiResult.data.Logo,
                    instituteMission:apiResult.data.Mission,
                    instituteVision:apiResult.data.Vision,
                    instituteShortName: apiResult.data.instituteShortName
                });
            }
        }
    }

    // METHOD TO GET INSTRUCTOR ASSIGNED INSTITUTE LIST
    GetInstructorAssignedInstituteList = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'GetInstructorAssignedInstituteIdArray',
            requestData,
            "/api/management/management.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstructorAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let iidArray = jsonResponse.APIResult.data;

                this.setState({ iidArray: iidArray }, () => {
                    this.apiCallToGetOverdueDetails();
                })
            }
        }
    }

    // API CALL METHOD TO GET OVERDUE DETAILS
    apiCallToGetOverdueDetails = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "iidArray": this.state.iidArray,
            "Module": "summary"
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'GetHelpDeskPendingInstallmentDueDateMessageForCentralFlow',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetOverdueDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let alertModal = false;
                let stepNumber = jsonResponse.APIResult.stepNumber;
                let dueIIdArray = jsonResponse.APIResult.dueIIdArray;
                let subscriptionWaring = jsonResponse.APIResult.subscriptionWaring;
                let userAcceptedHTML = jsonResponse.APIResult.userAcceptedHTML;
                let showModuleDetails = false;

                if (stepNumber > 2) {
                    alertModal = true;
                }
                // if ((stepNumber == 4 && apiResult.acceptanceSequenceIdArray.length == 1) || (stepNumber == 5 && apiResult.acceptanceSequenceIdArray.length == 2) || (stepNumber == 6 && apiResult.acceptanceSequenceIdArray.length == 3)) {
                //     alertModal = false;

                // }
                if ((stepNumber === 4 && apiResult?.acceptanceSequenceIdArray?.length === 1) ||
                    (stepNumber === 5 && apiResult?.acceptanceSequenceIdArray?.length === 2) ||
                    (stepNumber === 6 && apiResult?.acceptanceSequenceIdArray?.length === 3)) {
                    alertModal = false;
                }
                // if (stepNumber < 4 || (stepNumber == 4 && apiResult.acceptanceSequenceIdArray.length == 1) || (stepNumber == 5 && apiResult.acceptanceSequenceIdArray.length == 2) || (stepNumber == 6 && apiResult.acceptanceSequenceIdArray.length == 3)) {
                //     showModuleDetails = true;
                //     document.getElementById("hamburgerMenu").style.display = "block";
                //     this.getModuleDetails();
                // }
                // let acceptanceCount = apiResult.acceptanceSequenceIdArray.length + 1;
                if (stepNumber < 4 ||
                    (stepNumber === 4 && apiResult?.acceptanceSequenceIdArray?.length === 1) ||
                    (stepNumber === 5 && apiResult?.acceptanceSequenceIdArray?.length === 2) ||
                    (stepNumber === 6 && apiResult?.acceptanceSequenceIdArray?.length === 3)) {
                    showModuleDetails = true;
                    document.getElementById("hamburgerMenu").style.display = "block";
                    this.getModuleDetails();
                   
                }
                let acceptanceCount = (apiResult?.acceptanceSequenceIdArray?.length ?? 0) + 1;

                this.setState({
                    overdueCondition: apiResult.status,
                    overdueMessage: apiResult.message,
                    dueDate: apiResult.dueDate,
                    dateAfterSevenDays: apiResult.dateAfterSevenDays,
                    paymentAcceptanceObj: apiResult.paymentAcceptanceObj,
                    acceptanceSequenceIdArray: apiResult.acceptanceSequenceIdArray,
                    clientSubscriptionId: apiResult.clientSubscriptionId,
                    daysCount: apiResult.daysCount,
                    installmentId: apiResult.installmentId,
                    stepNumber,
                    alertModal,
                    showModuleDetails,
                    acceptanceCount,
                    billingMessage: apiResult.billingMessage,
                    isBillContact: apiResult.isBillContact,
                    dueIIdArray,
                    subscriptionWaring,
                    userAcceptedHTML
                });
            }
        }
    }

    // API CALL METHOD TO GET ADMIN DETAILS
    apiCallToGetAdminDetails = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'checkIsAdmin',
            requestData,
            '/api/instructor/facultyRegistration.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAdminDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    isAdmin: apiResult.isAdmin
                });
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC YEAR DETAILS
    apiCallToGetAcademicYearDetails = async () => {
        let jsonResponse = await HomeApiCall.makeApiCall(
            'GetAcademicYearListObject',
            { "iid": config.institute_id },
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray
                });
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT DETAILS
    apiCallToGetDepartmentDetails = async () => {

        this.setState({ loadingStreams: true });
        try {


            let requestData = {
                'faculty_id': config.faculty_id
            };

            let jsonResponse = await HomeApiCall.makeApiCall(
                'getFacultyAssignedStreamList',
                requestData,
                '/api/employeeManagement/employeemanagement.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToGetDepartmentDetails();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    this.setState({ userAssignedStreams: apiResult });
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setState({ loadingStreams: false });

        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO DISPLAY MESSAGE IF ACCESS NOT GRANTED
    accessGranted = () => {
        this.setState({
            successModal: true,
            successModalType: 'warning',
            successMessage: this.state.modalMessage
        });
    }
    //METHOD TO ACCEPT SUBSCRIPTION EXTENSION
    apiCallToAcceptExtension = async () => {
        this.setState({
            acceptingExtension: true
        })

        // let acceptanceCount = this.state.acceptanceSequenceIdArray.length + 1;
        let acceptanceCount = (this.state.acceptanceSequenceIdArray?.length ?? 0) + 1;
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "clientSubscriptionId": this.state.clientSubscriptionId,
            "installmentId": this.state.installmentId,
            "acceptanceCount": acceptanceCount,
            "dueDate": this.state.dueDate,
            "dateAfterSevenDays": this.state.dateAfterSevenDays,
            "dueIIdArray": this.state.dueIIdArray,
            "iidArray": this.state.iidArray,

        };
        let jsonResponse = await HomeApiCall.makeApiCall(
            'AddHelpDeskInstallmentAcceptanceDetailsForCentralFlow',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAcceptExtension();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;
                this.setState({
                    acceptingExtension: false
                })
                if (apiResult.status == "success") {
                    document.getElementById("hamburgerMenu").style.display = "block";
                    this.setState({
                        alertModal: false,
                        acceptanceCount,
                        showModuleDetails: true,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    }, () => this.getModuleDetails());
                } else {
                    this.setState({
                        alertModal: false,
                        showModuleDetails: true,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    })
                }
            }
        }
    }

    userSignOut = () => {
        var cookies = document.cookie.split(";");
        //function to delete cookie
        var delete_cookie = function (name) {
            document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = name + '=; Path=/; domain=.vmedulife.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        };
        //code to delete all cookies 
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            delete_cookie(name);
        }
    }

    // METHOD TO RETURN SUCCESS MODAL FOR TRANSITION / TRANSFER QUERY
    returnSubscriptionAlertModal = () => {
        return (
            <div
                className={this.state.alertModal ? "modal fade show" : "modal fade"}
                id="modalContainer"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-body SubscriptionAlertModal-body">
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    alignItems: "flex-end",
                                }}
                                className="col-md-12"
                            >
                                <a
                                    className=""
                                    style={{ cursor: "pointer" }}
                                    href={`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`}
                                    onClick={this.userSignOut}
                                >
                                    Log Out
                                </a>
                            </div>
                            <div className="step4">
                                <div className="col-md-10">
                                    {
                                        ReactHtmlParser(this.state.subscriptionWaring)
                                    }
                                </div>
                                <div className="col-md-2 ">
                                    <div className="warningIconContainer">
                                        <FontAwesomeIcon
                                            className="warningicon"
                                            icon={["fas", "exclamation-triangle"]}
                                            size="lg"
                                            color="#F44336"
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                ReactHtmlParser(this.state.userAcceptedHTML)
                            }



                            {this.state.stepNumber == 3 ? (
                                <div
                                    style={{ display: "flex", flexDirection: "row-reverse" }}
                                >
                                    <button
                                        className="btn outline-button backQueryButton"
                                        style={{ textTransform: "none", cursor: "Pointer" }}
                                        onClick={() => this.setState({ alertModal: false })}
                                    >
                                        Close
                                    </button>
                                </div>
                            ) : (
                                (this.state.stepNumber == 4 ||
                                    this.state.stepNumber == 5 ||
                                    this.state.stepNumber == 6) && this.state.isBillContact && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                        }}
                                    >
                                        <button
                                            className="btn acceptButton"
                                            style={{ textTransform: "none" }}
                                            onClick={() => this.apiCallToAcceptExtension()}
                                            disabled={this.state.acceptingExtension}
                                        >
                                            I, Accept
                                        </button>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    returnAdminSettingModel = () => {
        return (
            <div className={this.state.showAdminSetting ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header alert-header adminSettingHeader">
                            <div className="SettingsTitle">Settings</div>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.setState({ showAdminSetting: false })} />
                        </div>
                        <div className="modal-body AdminSettingModel-body">
                            <div className="AdminSetting">
                                <div className="col-md-4 AccessManagement management">
                                    <div className="ManagementTitle">Access Management</div>
                                    <a className="managementCards" href={`${config.RootUrl}/modules/accessmanagement/#/`} title="Manage access of faculty members for vmedulife portal." >
                                        <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Manage Employee Access</p>
                                    </a>

                                    <a className="managementCards" href={`${config.RootUrl}/faculty/Settings/LockAccess.php`} title="Lock / Unlock access of various modules." >
                                        <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Lock Unlock Access</p>
                                    </a>
                                </div>
                                <div className="col-md-4 AccessManagement management">
                                    <div className="ManagementTitle">User Management</div>
                                    <p style={{ fontSize: 14 }}>Employee Registration is moved under ERP modules. Check on summary/home page under ERP modules section.</p>
                                </div>
                                <div className="col-md-4 AccessManagement management">
                                    <div className="ManagementTitle">Settings</div>
                                    <a className="managementCards" href={`${config.RootUrl}/faculty/Settings/InstituteSettings.php`} title="Institute details settings." >
                                        <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Institute Settings</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO RETURN SUCCESS MODAL FOR TRANSITION / TRANSFER QUERY
    returnStreamSelectionModal = () => {
        return (
            <div className={this.state.selectAssignedStream ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-lg streamModal">
                    <div className="modal-content streamSelectionContent">
                        <div className='modal-header'>
                            <h5>Select Stream/Branch</h5>
                            <FontAwesomeIcon icon={['fas', 'times']} size="1x" color="#000" onClick={() => this.closeStreamSelection()} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body">
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th style={{ padding: 5 }}></th>
                                        <th style={{ padding: 5 }}>Sr. No.</th>
                                        <th style={{ padding: 5 }}>Institute Name</th>
                                        <th style={{ padding: 5 }}>Stream Name</th>
                                        <th style={{ padding: 5 }}>Institute Short Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Object.keys(this.state.userAssignedStreams).length > 0 ?
                                            Object.keys(this.state.userAssignedStreams).map((streamUniqueId, streamIndex) => {
                                                let assignedStreamData = this.state.userAssignedStreams[streamUniqueId];

                                                return (
                                                    <>
                                                        <tr>
                                                            <td style={{ padding: 5 }}>
                                                                <input type="radio" name="assignedStream" value={assignedStreamData.Id} onChange={(e) => this.getUserSelectedStream(e)} />
                                                            </td>
                                                            <td style={{ padding: 5 }}>{streamIndex + 1}</td>
                                                            <td style={{ padding: 5 }}>{ReactHtmlParser(assignedStreamData.instituteName)}</td>
                                                            <td style={{ padding: 5 }}>{assignedStreamData.Name}</td>
                                                            <td style={{ padding: 5 }}>{assignedStreamData.instituteShortName}</td>
                                                        </tr>
                                                    </>
                                                );
                                            })
                                            :
                                            <tr>
                                                <td style={{ padding: 5 }} colSpan={5}>Stream list not available.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <div>
                                <button className="btn primary-button waves-effect" onClick={() => this.setUserCookieStream()}>Select</button>
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeStreamSelection()}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO GET THE USER SELECTED STREAM
    getUserSelectedStream = (e) => {
        this.setState({
            tempSelectedDepartment: e.target.value
        });
    }

    // METHOD TO SET USER SELECTED STREAM 
    setUserCookieStream = () => {
        this.setState({
            selectedDepartment: this.state.tempSelectedDepartment
        },
            () => this.updateUserDetailsCookies()
        );
    }

    // METHOD TO CLOSE STREAM SELECTION MODAL
    closeStreamSelection = () => {
        if (this.state.selectedDepartment == "all") {
            this.setState({
                selectAssignedStream: false,
                selectedDepartment: config.stream_id || 0,
                tempSelectedDepartment: ''
            });
        }
        else {
            this.setState({
                selectAssignedStream: false,
                tempSelectedDepartment: ''
            });
        }

    }

    //function to get token cookies 00
    getCookie = (cname) => {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }



    //METHOD TO UPDATE USER_DETAILS COOKIES
    updateUserDetailsCookies = () => {
        let selectedAcademicYear = this.state.selectedAcademicYear;
        let year_text = this.state.academicYearList[selectedAcademicYear]["year_text"];
        let selectedDepartment = this.state.selectedDepartment;
        let departmentName = "";
        let assignedStreamDetails = {};
        if (selectedDepartment != "all") {
            this.closeStreamSelection();

            Object.keys(this.state.userAssignedStreams).map(streamUniqueId => {
                let assignedStreamData = this.state.userAssignedStreams[streamUniqueId];

                if (assignedStreamData.Id?.toString() == selectedDepartment?.toString()) {
                    departmentName = assignedStreamData.Name;
                    assignedStreamDetails = assignedStreamData;
                }
            })

            function setCookie(name, value) {
                document.cookie = name + "=" + (value || "") + ";path=/; ";
            }

            function setWcCookie(name,value) {
                document.cookie = name + "=" + (value || "") + "; path=/;domain=.vmedulife.com";
            }

            if (assignedStreamDetails.instituteName != undefined) {
                this.setState({
                    instituteName: assignedStreamDetails.instituteName
                });
            }

            var InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details_wc"))));
            InstructorDetailsJSON["data"]["AcaYear"] = year_text;
            InstructorDetailsJSON["data"]["AcaYearId"] = selectedAcademicYear;
            InstructorDetailsJSON["data"]["StreamId"] = selectedDepartment;
            InstructorDetailsJSON["data"]["StreamName"] = departmentName;
            InstructorDetailsJSON["data"]["InstituteName"] = assignedStreamDetails.instituteName;
            InstructorDetailsJSON["data"]["InstituteShortName"] = assignedStreamDetails.instituteShortName;
            setCookie("user_details", Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))));
            setWcCookie("user_details_wc", Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))));
            // window.location.replace(config.RootUrl + '/modules/summary/#/');            
            // window.location.replace('http://localhost:3000/');          
        }
        else {
            this.setState({
                selectAssignedStream: true
            });
        }
    }

    // METHOD TO REFRESH PAGE ON BUTTON CLICK
    // refreshPage = () => {
       
    // }
        refreshPage = () => {
             window.location.reload();
        if (this.leaderboardRef.current) {
            this.leaderboardRef.current.apiCallToGetLeaderboardCreditHistory();
        } else {
            console.warn("LeaderboardDetails component not yet loaded");
        }
    };

    render() {
        return (
            <>
                {
                    (this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) &&
                    <div className="subscriptionStrip" style={{ backgroundColor: (this.state.stepNumber > 1 || this.state.acceptanceCount > 1) ? '#EB5757' : this.state.stepNumber == 1 ? '#FF7800' : 'transparent', paddingTop: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 50 : 5, paddingBottom: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 0 : 2, height: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 0 : 'auto', zIndex: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? -1 : 19 }}>{this.state.overdueMessage}</div>
                }
                <div className='newMorque' style={{color:"black", zIndex: 19 ,marginBottom:'5px',paddingTop: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 55 : 10, paddingBottom: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 5 : 15, height: !(this.state.stepNumber >= 1 || this.state.acceptanceCount > 1) ? 0 : 'auto'}}>
                    <marquee >The new version of 'Summary' will automatically apply to all users starting from March 31, 2025.</marquee>
                </div>

                <div className="instituteDetails-container col-md-12" style={{ paddingTop: (this.state.stepNumber == 0 && this.state.acceptanceSequenceIdArray.length == 0) ? 60 : 90 }}>
                    <div className="instituteDetailsContainer">
                        <div className="instituteDetails">
                            <div className="instituteName">
                                {

                                    this.state.instituteLogo && this.state.instituteLogo.length > 0 && this.state.instituteLogo.split("/logo/")[1].length > 1 ?
                                        <img src={this.state.instituteLogo} height={40} width={40} />
                                        :
                                        <FontAwesomeIcon icon={['fas', 'university']} style={{ fontSize: 22 }} />

                                }

                                <p style={{ fontWeight: 'bold', fontSize: 22, color: '#4A4B57' }}>{ReactHtmlParser(this.state.instituteName)}</p>
                                <a href={`${config.RootUrl}/institute/home/${config.instructorInfo.InstituteUrl}`} target="_blank">
                                    <FontAwesomeIcon icon={['fas', 'external-link-alt']} color="#2F80ED" style={{ cursor: 'pointer' }} />
                                </a>
                                {/* Custom Button Switch To new Version */}

                                {/* <a href={`${config.RootUrl}/modules/myworkspace/#/`}>
                                    <span
                                        style={{
                                            width: 'auto',
                                            borderRadius: '20px',
                                            backgroundColor: "#0465AC",
                                            color: "#FFFFFF",
                                            border: 'none',
                                            padding: '6px',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '12px',
                                            marginRight: '5px',


                                        }}
                                    >
                                        Switch To New Summary Version
                                    </span>
                                </a> */}
                            </div>
                            <p style={{ fontSize: 13, color: '#5A5B6A', textAlign: 'justify', marginTop: 5 }}>vmedulife platform is dedicated to all faculties who have contributed their professional life for learning innovations, sharing knowledge across nations, reducing diversity across people and development for student's benefits to uplift overall quality of living across world.</p>
                        </div>

                        {/* following is my academic year and stream selection with setting and refresh icon */}
                        <div className="academicDetails">
                            <div className="academicYearSelection">
                                <select
                                    className="form-control selectionInput"
                                    value={this.state.selectedAcademicYear}
                                    onChange={(e) => this.setState({ selectedAcademicYear: e.target.value }, () => this.updateUserDetailsCookies())}
                                >
                                    {
                                       this.state.academicYearList && Object.keys(this.state.academicYearList).length > 0 &&
                                        this.state.academicYearSequence.map(yearId => {
                                            let year = this.state.academicYearList[yearId];

                                            return (
                                                <option value={yearId} key={yearId}>{year.year_text}</option>
                                            );
                                        })
                                    }
                                </select>
                                {
                                    this.state.isAdmin &&
                                    <FontAwesomeIcon icon={['fas', 'cog']} color="#2F80ED" style={{ cursor: 'pointer' }} onClick={() => this.setState({ showAdminSetting: true })} />
                                }
                            </div>
                            <div className="departmentSelection">
                                <select
                                    className="form-control selectionInput"
                                    value={this.state.selectedDepartment}
                                    onChange={(e) => this.setState({ selectedDepartment: e.target.value }, () => this.updateUserDetailsCookies())}
                                >
                                    {/* {
                                        config.streamInfo.length > 0 &&
                                        config.streamInfo.map(department => {
                                            return (
                                                <option value={department.Id} key={department.Id}>{department.Name + " | " + department.instituteShortName}</option>
                                            );
                                        })
                                    } */}
                                    {
                                        this.state.loadingStreams
                                            ?
                                            <ButtonLoader />
                                            :
                                            <>
                                                {Object.keys(this.state.userAssignedStreams).map((streamUniqueId, index) => {
                                                    let assignedStreamData = this.state.userAssignedStreams[streamUniqueId];
                                                    if (index < 15 || this.state.selectedDepartment?.toString() == assignedStreamData.Id) {
                                                        return (
                                                            <option value={assignedStreamData.Id} key={assignedStreamData.Id}>{assignedStreamData.Name + " | " + assignedStreamData.instituteShortName}</option>
                                                        );
                                                    } else return <></>

                                                })}
                                                <option value="all" >View All</option>
                                            </>
                                    }
                                </select>
                                {
                                    this.state.refreshingPage ?
                                        <ButtonLoader />
                                        :
                                        <FontAwesomeIcon icon={['fas', 'redo-alt']} title="Click here to refresh the page" color="#2F80ED" style={{ cursor: 'pointer' }} onClick={() => this.refreshPage()} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="moduleDetailsContainer">
                        <div className="moduleDetails">
                            {
                                this.state.showModuleDetails && <ModuleDetails />
                            }
                        </div>
                        <div className='recentUpdates-leaderboardDetails'>
                            <div className="assistanceCount">
                                {
                                    this.state.showModuleDetails &&
                                    <LatestUpdates
                                        showRecentUpdateModel={!this.state.alertModal}
                                        setRecentUpdate={this.setRecentUpdate}
                                    />
                                }
                            </div>
                            {
                                this.state.showModuleDetails &&
                                // <LeaderboardDetails academicYear={this.state.selectedAcademicYear} />
                                  <LeaderboardDetails
                                        ref={this.leaderboardRef}
                                        academicYear={this.state.selectedAcademicYear}
                                        department={this.state.selectedDepartment}
                                    />
                            }
                        </div>
                    </div>
                    <div className="leaderboardContainer">
                        <div className="birthdayNoticeEventContainer">
                            <div className="birthdayContainer">
                                {
                                    this.state.showModuleDetails &&
                                    <BirthdayDetails />
                                }
                            </div>
                            <div className="noticeEventDetails">
                                <div className="noticeDetails">
                                    {
                                        this.state.showModuleDetails &&
                                        <NoticeDetails
                                            academicYear={this.state.selectedAcademicYear}
                                        />
                                    }
                                </div>
                                <div className="eventDetails">
                                    {
                                        this.state.showModuleDetails &&
                                        <EventDetails
                                            academicYear={this.state.selectedAcademicYear}
                                            department={this.state.selectedDepartment}
                                        />
                                    }
                                </div>
                                <div className="academicPlanning">
                                    {
                                        this.state.showModuleDetails &&
                                        <LectureDetails
                                            academicYear={this.state.selectedAcademicYear}
                                            department={this.state.selectedDepartment}
                                        />
                                    }

                                </div>
                                <div className="academicPlanning">
                                    {
                                        this.state.showModuleDetails &&
                                        <EmployeesOnLeave
                                            academicYear={this.state.selectedAcademicYear}
                                            department={this.state.selectedDepartment}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='visionMission'>
                        <div className='vision'>
                            <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Vision - {ReactHtmlParser(this.state.instituteShortName)}</p>
                            <p style={{ fontSize: 12, color: '#5A5B6A', textAlign: 'justify', whiteSpace: "pre-line" }}>{ReactHtmlParser(this.state.instituteVision)}</p>
                        </div>
                        <div className='mission'>
                            <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Mission - {ReactHtmlParser(this.state.instituteShortName)}</p>
                            <p style={{ fontSize: 12, color: '#5A5B6A', textAlign: 'justify', whiteSpace: "pre-line" }}>{ReactHtmlParser(this.state.instituteMission)}</p>
                        </div>
                    </div>
                    <div className='visionMission'>
                        <div className='vision'>
                            <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Vision - {ReactHtmlParser(this.state.streamName)}</p>
                            <p style={{ fontSize: 12, color: '#5A5B6A', textAlign: 'justify', whiteSpace: "pre-line" }}>{ReactHtmlParser(this.state.departmentVision)}</p>
                        </div>
                        <div className='mission'>
                            <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Mission - {ReactHtmlParser(this.state.streamName)}</p>
                            <p style={{ fontSize: 12, color: '#5A5B6A', textAlign: 'justify', whiteSpace: "pre-line" }}>{ReactHtmlParser(this.state.departmentMission)}</p>
                        </div>
                    </div>
                    <br/>
                    <br/>
                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.returnSubscriptionAlertModal()
                }
                {
                    this.returnAdminSettingModel()
                }
                {
                    this.returnStreamSelectionModal()
                }
            </>
        );
    }
}

export default Home;